import { get } from 'lodash'

const getCurrentTeam = () => get(window, 'state.currentTeam')

export default getCurrentTeam
